import { required, Spacer } from '@jfs/ui-new'
import { notRequired } from '@jfs/ui-new/src/utils/validations'
import { getValueFromLOVDescription } from '../../../../utils'
import { DropdownWithInfo } from '../comps/DropdownWithInfo'
import { TextInputWithInfo } from '../comps/TextInputWithInfo'
import { getDropdownData } from './dropdownData'
import { styles } from './styles'
import { landlineValidation, webAddressValidation } from './validations'
//businessChannel

const hideOnlineChannelFields = (lovData: any) => (values: any) =>
  getValueFromLOVDescription(lovData, values?.businessChannel, 'BusinessChannel') !== '1'

const hidedefferedDeliveryOption = (lovData: any) => (values: any) =>
  getValueFromLOVDescription(lovData, values?.businessChannel, 'BusinessChannel') !== '1' ||
  getValueFromLOVDescription(lovData, values?.riskDeliveryPeriod, 'DeliveryMode') !== 'D'

const shouldShowCustomTxnCountField = (lovData: any) => (value: any) =>
  getValueFromLOVDescription(lovData, value, 'DailyTransactionVolume') === '2'

const shouldShowCustomTxnValueField = (lovData: any) => (value: any) =>
  getValueFromLOVDescription(lovData, value, 'DailyTransactionValue') === '3'

export const otherBusinessDetailsForm = (entityLovs: any[], editable: boolean, isStoreMerchant: boolean) => ({
  key: 'OTHER_BUSINESS_DETAILS_FORM',
  verticalFlex: 1,
  contentOverflow: 'auto',
  horizontalFlex: 1,
  contentPadding: 24,
  title: 'Other Business Details',
  formItems: [
    {
      horizontalComps: [
        {
          fieldName: 'businessWebsite',
          ComponentName: TextInputWithInfo,
          label: 'Business Website',
          placeholder: 'Business Website',
          hideComponent: hideOnlineChannelFields(entityLovs),
          validationSchema: isStoreMerchant ? notRequired : webAddressValidation,
          ...styles.textinputStyle(editable),
          testID: 'businessWebsite',
        },
      ],
      horizontalSpacing: 8,
    },
    {
      horizontalComps: [
        {
          fieldName: 'landlineNumber',
          ComponentName: TextInputWithInfo,
          label: 'Land line number (Optional)',
          placeholder: 'STD Code + Landline Number',
          validationSchema: landlineValidation,
          ...styles.textinputStyle(editable),
          testID: 'landlineNumber',
        },
        {
          fieldName: 'dailyTransactionValue',
          ComponentName: DropdownWithInfo,
          label: 'Daily Transaction Value',
          title: 'Select Daily Transaction Value',
          validationSchema: required,
          data: getDropdownData(entityLovs, 'DailyTransactionValue'),
          dataFieldToRead: 'description',
          ...styles.dropDownStyle(editable),
          shouldShowCustomInputField: shouldShowCustomTxnValueField(entityLovs),
          minCustomVal: 40000,
          testID: 'dailyTransactionValue',
        },
        {
          fieldName: 'dailyTransactionCount',
          ComponentName: DropdownWithInfo,
          label: 'Daily Transaction Count',
          title: 'Select Daily Transaction Count',
          validationSchema: required,
          data: getDropdownData(entityLovs, 'DailyTransactionVolume'),
          dataFieldToRead: 'description',
          ...styles.dropDownStyle(editable),
          shouldShowCustomInputField: shouldShowCustomTxnCountField(entityLovs),
          testID: 'dailyTransactionCount',
          minCustomVal: 100,
        },
      ],
      horizontalSpacing: 8,
    },
    {
      horizontalComps: [
        {
          fieldName: 'riskDeliveryPeriod',
          ComponentName: DropdownWithInfo,
          label: 'Delivery Period',
          title: 'Select Delivery Period',
          validationSchema: isStoreMerchant ? notRequired : required,
          selectable: editable,
          data: getDropdownData(entityLovs, 'DeliveryMode'),
          hideComponent: hideOnlineChannelFields(entityLovs),
          dataFieldToRead: 'description',
          ...styles.dropDownStyle(editable),
          testID: 'riskDeliveryPeriod',
        },
        {
          fieldName: 'riskDeferredDeliveryOptions',
          ComponentName: DropdownWithInfo,
          label: 'Defferred Delivery Options',
          title: 'Select Defferred Delivery Options',
          validationSchema: isStoreMerchant ? notRequired : required,
          selectable: editable,
          data: getDropdownData(entityLovs, 'DeferredDeliveryOptions'),
          hideComponent: hidedefferedDeliveryOption(entityLovs),
          dataFieldToRead: 'description',
          ...styles.dropDownStyle(editable),
          testID: 'deferredDeliveryOptions',
        },
        {
          fieldName: 'spacer0',
          ComponentName: Spacer,
        },
      ],
      horizontalSpacing: 8,
    },
  ],
  onSubmit: async (values) => {},
})
